import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const next = new URLSearchParams(location.search).get('next') || '/platform';

  useEffect(() => {
    if (user) navigate(next, { replace: true });
  }, [user, navigate, next]);

  const handleSuccess = async (credentialResponse) => {
    try {
      await login(credentialResponse.credential);
      navigate(next, { replace: true });
    } catch (err) {
      alert(err?.response?.data?.error || 'Login failed. Please try again.');
      console.error(err);
    }
  };

  const handleDemoLogin = async () => {
    // For demo purposes, skip Google and use a test endpoint
    // In production, remove this or gate it behind a flag
    try {
      await login('DEMO_TOKEN');
      navigate(next, { replace: true });
    } catch {
      alert('Demo mode unavailable — configure a real Google Client ID.');
    }
  };

  return (
    <div className="login-page">
      <div style={{ position: 'absolute', top: -120, right: -120, width: 500, height: 500, background: 'radial-gradient(circle,rgba(37,99,235,.15) 0%,transparent 70%)', borderRadius: '50%', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -80, left: -80, width: 400, height: 400, background: 'radial-gradient(circle,rgba(217,119,6,.12) 0%,transparent 70%)', borderRadius: '50%', pointerEvents: 'none' }} />

      <div className="login-card">
        <div className="login-logo">ITC</div>
        <h1 className="login-title">أهلاً بك</h1>
        <p className="login-sub">
          منصة التدريب على اختبارات اللغة الإنجليزية<br />
          كلية التقنية الدولية بالرياض
        </p>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => alert('Google login failed. Check your Client ID.')}
            text="continue_with"
            locale="ar"
            theme="outline"
            size="large"
            shape="rectangular"
            width="352"
          />
        </div>

        <div className="login-divider">أو</div>

        <button className="demo-btn" onClick={handleDemoLogin}>
          <span style={{ fontSize: 16 }}>🎓</span>
          <span>متابعة كزائر (وضع التجربة)</span>
        </button>

        <p style={{ fontSize: 11, color: 'var(--mu2)', marginTop: 24, lineHeight: 1.7, fontFamily: 'Cairo, sans-serif' }}>
          بتسجيل الدخول، أنت توافق على استخدام هذه المنصة لأغراض التدريب الأكاديمي فقط
        </p>
      </div>
    </div>
  );
}
